import { getISOWeek, getQuarter, parseISO } from "date-fns";

export function collectTimeKeysFromTree(
  tree: {
    business_goal: string;
    children: {
      plan: string;
      campaign_id: string;
      children: {
        scenario: string;
        start_date: string;
        end_date: string;
        geography: string;
        rows: Record<string, string>[];
      }[];
    }[];
  }[]
): string[] {
  const keys = new Set<string>();

  for (const goal of tree) {
    for (const plan of goal.children) {
      for (const scenario of plan.children) {
        for (const row of scenario.rows) {
          for (const key of Object.keys(row)) {
            if (/^\d{4}-\d{2}-\d{2}$/.test(key)) keys.add(key);
          }
        }
      }
    }
  }

  return Array.from(keys).sort((a, b) => new Date(a).getTime() - new Date(b).getTime());
}

export function makeTimeHeaderTitle(dateKey: string, mode: string): string {
  const d = parseISO(dateKey);

  switch (mode) {
    case "week": {
      const isoWeek = getISOWeek(d);
      const isoYear = d.getUTCFullYear();
      return `W${String(isoWeek).padStart(2, "0")} ${isoYear}`;
    }
    case "quarter": {
      const q = getQuarter(d);
      const y = d.getUTCFullYear();
      return `Q${q} ${y}`;
    }
    case "month":
    default:
      return dateKey;
  }
}
